__turbopack_context__.v({
  "editor": "HeroEditor-module__nEfnpW__editor",
  "preview": "HeroEditor-module__nEfnpW__preview",
  "previewBody": "HeroEditor-module__nEfnpW__previewBody",
  "previewContainer": "HeroEditor-module__nEfnpW__previewContainer",
  "properties": "HeroEditor-module__nEfnpW__properties",
});
